import { useCallback, useEffect, useLayoutEffect, useRef, useState } from 'react'

export function useIsTruncated<T extends HTMLElement>() {
  const ref = useRef<T | null>(null)
  const [isTruncated, setIsTruncated] = useState(false)

  const checkTruncation = useCallback(() => {
    const el = ref.current
    if (!el) return
    setIsTruncated(el.scrollWidth > el.clientWidth + 1 || el.scrollHeight > el.clientHeight + 1)
  }, [])

  // Use layout effect to avoid flickering
  useLayoutEffect(() => {
    checkTruncation()
  }, [checkTruncation])

  useEffect(() => {
    const el = ref.current

    if (!el) return

    const observer = new ResizeObserver(checkTruncation)
    observer.observe(el)
    window.addEventListener('resize', checkTruncation)

    return () => {
      observer.disconnect()
      window.removeEventListener('resize', checkTruncation)
    }
  }, [checkTruncation])

  return [isTruncated, ref] as const
}
